export enum Gender {
  Male = "male",
  Female = "female",
  TransMale = "transMale",
  TransFemale = "transFemale",
  NonBinary = "nonBinary",
  Unknown = "unknown",
}

export class GenderHelper {
  static getTitle(gender: Gender): string {
    switch (gender) {
      case Gender.Male:
        return "Male";
      case Gender.Female:
        return "Female";
      case Gender.TransMale:
        return "Trans male";
      case Gender.TransFemale:
        return "Trans female";
      case Gender.NonBinary:
        return "Non-binary";
      case Gender.Unknown:
        return "I'd rather not say";
    }
  }

  static availableGenders(): Gender[] {
    return [
      Gender.Female,
      Gender.Male,
      Gender.TransFemale,
      Gender.TransMale,
      Gender.NonBinary,
      Gender.Unknown,
    ];
  }

  static fromFirebaseValue(value: string | null | undefined): Gender {
    if (!value) {
      return Gender.Unknown;
    }

    switch (value) {
      case "male":
        return Gender.Male;
      case "female":
        return Gender.Female;
      case "transMale":
        return Gender.TransMale;
      case "transFemale":
        return Gender.TransFemale;
      case "nonBinary":
        return Gender.NonBinary;
      case "unknown":
      default:
        return Gender.Unknown;
    }
  }

  static toFirebaseValue(gender: Gender): string {
    return gender;
  }
}
